
<!-- Formulario -->
<form  #registro="ngForm"  class="w-full py-3  px-5 flex flex-col gap-2">
    <!-- label ciclo-->
    <button [matMenuTriggerFor]="menuCiclo" class="p-0 min-h-0">
    <app-chip [text]="this.cicloLabel" class="bg-sky-500 w-48 rounded-lg"></app-chip>
    </button>
    <mat-menu #menuCiclo="matMenu">
        <button mat-menu-item *ngFor="let c of ciclos" (click)="onSelectCiclo(c)">
            {{ c.descripcion }}
        </button>
    </mat-menu>


    <!-- Campos de formulario -->
     <div class="flex flex-row gap-4 mt-5 w-full">
        <!-- Código de área -->
        <div class="bg-gray-200 w-full flex flex-row gap-2  items-center justify-between p-3">
            <span class="text-sm font-bold w-3/12 ">Código de área</span>
            <input type="text" [(ngModel)]="carreaModel.codigo" name="codigo" id="codigo" class="w-full rounded-lg" readonly>
        </div>

        <!-- Área -->
        <div class="bg-gray-200 w-full flex flex-rowg gap-2   items-center justify-between p-3">
            <span class="text-sm font-bold  mr-3 ">Área</span>
            <div class="w-full">
                <input
                    class="w-full"
                    matInput
                    type="text"
                    name="areaSearch"
                    placeholder="Buscar área"
                    [ngModel]="areaSearchTerm"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onAreaInput($event)"
                    [matAutocomplete]="areaAuto">

                <mat-autocomplete
                    #areaAuto="matAutocomplete"
                    [displayWith]="displayTipologia"
                    (optionSelected)="onAreaSelected($event)">
                    <mat-option *ngFor="let a of filteredAreasCarrera" [value]="a">
                        {{ a.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
    </div>

    <!-- Sub Area -->
    @if (esCicloDiversificado()) {
        <div class="bg-gray-200 w-full flex flex-rowg gap-2   items-center justify-between p-3">
            <span class="text-sm font-bold  mr-3 ">Subárea:</span>
            <div class="w-full">
                <input class="w-full"
                    matInput
                    type="text"
                    name="subareaSearch"
                    placeholder="Buscar subárea"
                    [ngModel]="subareaSearchTerm"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onSubareaInput($event)"
                    [matAutocomplete]="subareaAuto">

                <mat-autocomplete
                    #subareaAuto="matAutocomplete"
                    [displayWith]="displayTipologia"
                    (optionSelected)="onSubareaSelected($event)">
                    <mat-option *ngFor="let s of filteredSubareasCarrera" [value]="s">
                        {{ s.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
    }

    @if (!esCicloDiversificado()) {
        <div class="flex flex-row  gap-2 w-full">
            <!-- Orientacion -->
            <div class="bg-gray-200 w-full flex flex-row gap-2  items-center justify-between p-3">
                <span class="text-sm font-bold  "> Orientación</span>
                <div class="w-full">
                    <input
                        class="w-full"
                        matInput
                        type="text"
                        name="orientacionSearch"
                        placeholder="Buscar orientación"
                        [ngModel]="orientacionSearchTerm"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onOrientacionInput($event)"
                        [matAutocomplete]="orientacionAuto">

                    <mat-autocomplete
                        #orientacionAuto="matAutocomplete"
                        [displayWith]="displayTipologia"
                        (optionSelected)="onOrientacionSelected($event)">
                        <mat-option *ngFor="let o of filteredOrientacionesCarrera" [value]="o">
                            {{ o.descripcion }}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>

            <!-- Orientación Ocupacional -->
            <div class="bg-gray-200 w-full flex flex-rowg gap-2   items-center justify-between p-3">
                <span class="text-sm font-bold  w-6/12 ">Orientación Ocupacional</span>
                <div class="w-full">
                    <input
                        class="w-full"
                        matInput
                        type="text"
                        name="orientacionOcupacionalSearch"
                        placeholder="Buscar orientación ocupacional"
                        [ngModel]="orientacionOcupacionalSearchTerm"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onOrientacionOcupacionalInput($event)"
                        [matAutocomplete]="orientacionOcupacionalAuto">

                    <mat-autocomplete
                        #orientacionOcupacionalAuto="matAutocomplete"
                        [displayWith]="displayTipologia"
                        (optionSelected)="onOrientacionOcupacionalSelected($event)">
                        <mat-option *ngFor="let oo of filteredOrientacionesOcupacionales" [value]="oo">
                            {{ oo.descripcion }}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>
        </div>
    }

    @if (esCicloDiversificado()) {
        <!-- Carrera -->
        <div class="bg-gray-200 w-full flex flex-rowg gap-2   items-center justify-between p-3">
            <span class="text-sm font-bold  mr-3 ">Carrera:</span>
            <div class="w-full">
                <input
                    class="w-full"
                    matInput
                    type="text"
                    name="carreraSearch"
                    placeholder="Buscar carrera"
                    [ngModel]="carreraSearchTerm"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onCarreraInput($event)"
                    [matAutocomplete]="carreraAuto">

                <mat-autocomplete
                    #carreraAuto="matAutocomplete"
                    [displayWith]="displayTipologia"
                    (optionSelected)="onCarreraSelected($event)">
                    <mat-option *ngFor="let c of filteredCarreras" [value]="c">
                        {{ c.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </div>
        </div>
    }

    <!-- Modalidad -->
    @if (!esCicloDiversificado()) {
        <div class="bg-gray-200 w-full flex flex-rowg gap-2   items-center justify-between p-3">
            <span class="text-sm font-bold  mr-3 ">Modalidad:</span>
            <div class="w-full">
                <mat-select [(ngModel)]="carreaModel.modalidad" name="modalidad" id="modalidad">
                    <mat-option value="N/A">N/A</mat-option>
                    <mat-option *ngFor="let m of modalidad" [value]="m.descripcion">
                        {{ m.descripcion }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
    }

        <!-- Profesiona -->
    <div class="bg-gray-200 w-full flex flex-rowg gap-2   items-center justify-between p-3">
        <span class="text-sm font-bold  mr-3 ">Profesional:</span>
        <div class="w-full">
            <mat-select [(ngModel)]="carreaModel.profesional" name="profesional" id="profesional">
                <mat-option *ngFor="let p of tipoProfesional" [value]="p.descripcion">
                    {{ p.descripcion }}
                </mat-option>
            </mat-select>
        </div>
    </div>


    <!-- PALABRAS CLAVE -->

    <mat-form-field class="w-full flex flex-col" appearance="outline">
        <mat-label>Palabras Clave:</mat-label>

        <!--seleccionadas-->
        <mat-chip-grid #chipGrid aria-label="word selection">
            @for (word of words(); track $index) {
                <mat-chip-row (removed)="remove(word)">
                {{word}}
                <button matChipRemove [attr.aria-label]="'remove ' + word">
                    <mat-icon>cancel</mat-icon>
                </button>
                </mat-chip-row>
            }
        </mat-chip-grid>


        <input
            name="currentWord"
            placeholder=""
            #fruitInput
            [(ngModel)]="currentWord"
            [matChipInputFor]="chipGrid"
            [matAutocomplete]="auto"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)"/>

        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event); fruitInput.value = ''">
            @for (word of filteredWords(); track word) {
                <mat-option [value]="word">{{word}}</mat-option>
            }
        </mat-autocomplete>

    </mat-form-field>

    @if( carreaModel.carreraId === 0) {
        <!-- Agregar -->
        <button mat-flat-button
            *appControlAcceso="'lectura'"
            color="primary" (click)="crearRegistro()"
            type="submit" [disabled]="!registro.valid"
            >Agregar Registro
        </button>
    }
    @else {
        <!--Actualizar-->
        <button mat-flat-button
            *appControlAcceso="'lectura'"
            color="primary" (click)="Actualizar()"
            type="submit" [disabled]="!registro.valid">
            Actualizar Registro
        </button>

    }



</form>
